import { render, staticRenderFns } from "./next_detail.vue?vue&type=template&id=36163c5f&scoped=true&"
import script from "./next_detail.vue?vue&type=script&lang=js&"
export * from "./next_detail.vue?vue&type=script&lang=js&"
import style0 from "./next_detail.vue?vue&type=style&index=0&id=36163c5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36163c5f",
  null
  
)

export default component.exports